import React from "react";
import {Card} from "reactstrap";
import {useNavigate} from "react-router";
import Button from "../Button";
const Fallback = () => {
  const navigate = useNavigate();

  const navigateToHome = () => {
    navigate("/app/home");
  };
  return (
    <Card style={{margin: "20px 0px", border: "1px solid #ddd"}}>
      <div
        style={{minHeight: "200px"}}
        className="d-flex justify-content-center align-items-center"
      >
        <p className="roboto-bold" style={{fontSize: "20px", textAlign: "center"}}>
          You do not have permission to view this page
        </p>
      </div>
      <div
        style={{borderTop: "1px solid #ddd", padding: "10px 20px"}}
        className="d-flex justify-content-end"
      >
        <div style={{width: "120px"}}>
          <Button onClick={navigateToHome}>Home Page</Button>
        </div>
      </div>
    </Card>
  );
};

export default Fallback;
